import { css } from "@emotion/react"
import styled from "@emotion/styled"
import { breakpoint, spacingFluidSm, spacingStaticLg } from "@porsche-design-system/components-react/emotion"
import type { PropsWithChildren } from "react"
import { shouldForwardProp } from "src/common/shouldForwardProp"

interface ButtonGroupProps {
	direction?: "row" | "column"
	withoutMarginTop?: boolean
}

export const ButtonGroup = ({ direction, withoutMarginTop, ...rest }: PropsWithChildren<ButtonGroupProps>) => {
	return <Layout {...rest} $direction={direction} $withoutMarginTop={withoutMarginTop} role="group" />
}

const columnCss = css`
	flex-flow: column nowrap;
	align-items: stretch;
`

const rowCss = css`
	flex-flow: row wrap;
	align-items: center;
`

// based on PButtonGroup: https://github.com/porsche-design-system/porsche-design-system/blob/v3/packages/components/src/components/button-group/button-group-styles.ts#L18
const Layout = styled("div", { shouldForwardProp })<{ $direction?: "row" | "column"; $withoutMarginTop?: boolean }>`
    display: flex;
	gap: ${spacingFluidSm};
	${({ $withoutMarginTop }) => !$withoutMarginTop && `margin-top: ${spacingStaticLg};`}
	${({ $direction }) =>
		$direction === "column"
			? columnCss
			: $direction === "row"
				? rowCss
				: css`
	${columnCss};
	@media (min-width: ${breakpoint.xs}px) {
		${rowCss};
	}
	`}
`
